import styled from 'styled-components';
import { SpacerProps } from './type';

const Spacer = styled.div<SpacerProps>``;

export default Spacer;